import { Injectable } from '@angular/core';
import { NgbDateAdapter, NgbDateStruct } from '@ng-bootstrap/ng-bootstrap';

@Injectable()
export class CustomStringDateAdapter extends NgbDateAdapter<string> {
    // From string (yyyymmdd) to NgbDateStruct
    fromModel(value: string | null): NgbDateStruct | null {
        if (!value) {
            return null;
        }

        const year = parseInt(value.substring(0, 4), 10);
        const month = parseInt(value.substring(4, 6), 10);
        const day = parseInt(value.substring(6, 8), 10);

        return { year, month, day };
    }

    // From NgbDateStruct to string (yyyymmdd)
    toModel(date: NgbDateStruct | null): string | null {
        if (!date) {
            return null;
        }

        // Ensure month and day are zero-padded
        const month = date.month.toString().padStart(2, '0');
        const day = date.day.toString().padStart(2, '0');

        return `${date.year}${month}${day}`;
    }
}
